import {
    tss,
} from 'app/tss'

export default tss.create({
    wrapper: {
        paddingBottom: 0,
    },
})
